/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import BaseURL from "../../BaseURL/BaseURL";
import { useEffect } from "react";
import axios from "axios";
const Podcast = () => {
  const [data, setData] = useState([]);
  const [Filter, setFilter] = useState([]);

  useEffect(() => {
    try {
      var config = {
        method: "get",
        url: `${BaseURL.baseurl}/api/podcasts`,
        data: data,
        headers: {
          Accept: "application/json",
          // Authorization: `Bearer ${token}`,
        },
      };
      axios(config)
        .then((response) => {
          console.log(response);
          setData(response?.data?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {}
  }, []);

  const handleinput = (e) => {
    const { name, value } = e.target;
    setFilter(
      data.filter((item) => {
        const itemName = item.title.toLowerCase();
        const itemDate = item.date.toLowerCase();

        const filterName =
          name === "name" && itemName.includes(value?.toLowerCase());
        const filterDate =
          name === "date" && itemDate.includes(value?.toLowerCase());

        return filterName || filterDate;
      })
    );
  };

  console.log(data, Filter, "========");

  return (
    <>
      <Header />
        <div className="container">
          <div className="row text-center pt-4">
            <h1>Podcast</h1>
          </div>
          <div className="row py-4 d-flex justify-content-center">
            <div className="col-lg-7 col-10 p-0 mb-2 mb-lg-0">
              <input
                type="search"
                className="rounded-0 p-3 border border-success w-100"
                name="name"
                placeholder="search By Title"
                onChange={handleinput}
              />
            </div>
            <div className="col-lg-3 col-10 p-0">
              <input
                type="date"
                className="rounded-0 p-3 border border-success w-100"
                name="date"
                onChange={handleinput}
              />
            </div>
          </div>
          </div>
          <div className="container-fluid">
            <div className="row">
              {Filter.length !== 0 ? (
                <>
                  {Filter?.map((data, index) => {
                    return (
                      <>
                        <div
                          className={` col-md-3 m-0 m-lg-5 mb-4 mb-lg-0${
                            Filter.length == 1 ? "w-100" : null
                          }`}
                          style={{
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                            height: "330px",
                          }}
                        >
                          {data.video !== "" ? (
                            <>
                              <video
                                controls
                                autoplay
                                width="100%"
                                height="250px"
                              >
                                <source src={data.video} type="video/mp4" />
                              </video>
                            </>
                          ) : (
                            <>
                              <iframe src={data.link} title="link"></iframe>
                            </>
                          )}
                          <h5 className="px-2">{data.title}</h5>
                          <p className="px-2">{data.date}</p>
                        </div>
                      </>
                    );
                  })}
                </>
              ) : (
                <>
                  {data?.map((data, index) => {
                    return (
                      <>
                        <div
                          className="col-md-3 m-0 m-lg-5 mb-4 mb-lg-0"
                          style={{
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                            height: "fit-content",
                          }}
                        >
                          {data.video !== "" ? (
                            <>
                              <video
                                controls
                                autoplay
                                width="100%"
                                height="250px"
                              >
                                <source src={data.video} type="video/mp4" />
                              </video>
                            </>
                          ) : (
                            <>
                              <iframe width='100%' height='250px' src={data.link} title="link"></iframe>
                            </>
                          )}
                          <h5 className="px-2">{data.title}</h5>
                          <p className="px-2">{data.date}</p>
                        </div>
                      </>
                    );
                  })}
                </>
              )}
            </div>
          </div>
      
      <Footer />
    </>
  );
};

export default Podcast;
